import { createContext, useContext } from "react"

import { ObjectsViewContextValues } from "./ObjectsView.types"

// `any` is used here as workaround because it is not possible to create a context with a generic type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ObjectsViewContext = createContext<ObjectsViewContextValues<any> | undefined>(undefined)
ObjectsViewContext.displayName = "ObjectsView"

export default function useObjectsView<T>(): ObjectsViewContextValues<T> {
    const context = useContext(ObjectsViewContext)
    if (!context) {
        throw new Error("useObjectsView must be used within an ObjectsView.Provider component")
    }

    return context as ObjectsViewContextValues<T>
}
